{
  "panel": {
    "title": "Madokezo",
    "newNote_title": "Dokezo jipya",
    "search_placeholder": "Tafuta madokezo…",
    "search_aria": "Tafuta madokezo",
    "clearSearch_aria": "Futa utafutaji",
    "editorPlaceholder": "Unafikiria nini…",
    "titleInput_placeholder": "Hakuna Kichwa",
    "untitled": "Bila kichwa",
    "emptyNote": "Dokezo tupu",
    "loadingNotes": "Inapakia madokezo…",
    "noNotesYet": "Bado hakuna madokezo. Gusa + kuunda moja.",
    "noResults": "Hakuna matokeo kwa \"{{query}}\"",
    "noNotesTagged": "Hakuna madokezo yenye lebo {{tag}}",
    "tagFilterAll": "Zote",
    "filterByTag_aria": "Chuja kwa lebo",
    "templates": "Violezo",
    "editorTheme_aria": "Mandhari ya kihariri",
    "themeActive_aria": "Mandhari ya {{theme}} (hai)",
    "theme_aria": "Mandhari ya {{theme}}",
    "themeName": {
      "dark": "Giza",
      "sepia": "Sepia",
      "light": "Mwanga",
      "forest": "Msitu"
    },
    "voice": "Sauti",
    "voice_title": "Dokezo la sauti",
    "voiceUnavailable_title": "Usemi haupatikani katika kivinjari hiki",
    "openVoiceRecorder_aria": "Fungua kinasa dokezo la sauti",
    "summarizing_title": "Inafanya muhtasari…",
    "summarize_title": "Fanya muhtasari",
    "summarizeNote_aria": "Fanya muhtasari wa dokezo",
    "aiCommands_title": "Amri za AI  Cmd+K",
    "openAiPalette_aria": "Fungua paleti ya amri za AI",
    "enterFocusMode_title": "Hali ya umakini  Cmd+Shift+F",
    "exitFocusMode_title": "Toka hali ya umakini  Cmd+Shift+F",
    "enterFocusMode_aria": "Ingia hali ya umakini",
    "exitFocusMode_aria": "Toka hali ya umakini",
    "export_title": "Hamisha dokezo",
    "delete_title": "Futa dokezo",
    "delete_aria": "Futa dokezo",
    "moreActions_title": "Vitendo zaidi",
    "wordCount_one": "Neno {{formatted}} · ~dakika {{minutes}} za kusoma",
    "wordCount_other": "Maneno {{formatted}} · ~dakika {{minutes}} za kusoma",
    "referencedBy_one": "Imerejelewa na {{count}}",
    "referencedBy_other": "Imerejelewa na {{count}}",
    "noMatchingNotes": "Hakuna madokezo yanayolingana",
    "mobileTabs_aria": "Mwonekano wa madokezo",
    "mobileTabNotes": "Madokezo",
    "mobileTabEditor": "Kihariri",
    "saveFailed": "Imeshindwa kuhifadhi dokezo: {{message}}",
    "deleteFailed": "Imeshindwa kufuta dokezo",
    "loadFailed": "Imeshindwa kupakia madokezo",
    "analyzeFailed": "Imeshindwa kuchanganua dokezo",
    "aiCommandFailed": "Amri ya AI imeshindwa",
    "unknownError": "Hitilafu isiyojulikana"
  },
  "paywall": {
    "title": "Madokezo ni sehemu ya Rhemn Pro",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "Fungua madokezo yaliyolandanishwa, uandishi kwa sauti kupitia kivinjari, na muhtasari wa AI uliopangwa."
  },
  "format": {
    "bold": "Mzito",
    "italic": "Mlazo",
    "strikethrough": "Mstari katikati",
    "inlineCode": "Msimbo wa ndani",
    "heading1": "Kichwa 1",
    "heading2": "Kichwa 2",
    "heading3": "Kichwa 3",
    "bulletList": "Orodha ya alama",
    "numberedList": "Orodha ya namba",
    "blockquote": "Nukuu",
    "codeBlock": "Kizuizi cha msimbo",
    "toggleBold_aria": "Geuza mzito",
    "toggleItalic_aria": "Geuza mlazo",
    "toggleStrikethrough_aria": "Geuza mstari katikati",
    "toggleInlineCode_aria": "Geuza msimbo wa ndani",
    "toggleBulletList_aria": "Geuza orodha ya alama",
    "toggleNumberedList_aria": "Geuza orodha ya namba",
    "toggleBlockquote_aria": "Geuza nukuu",
    "formatOptions_aria": "Chaguo za umbizo"
  },
  "analysis": {
    "heading": "Muhtasari",
    "onDevice": "⚡ Kwenye kifaa",
    "onDevice_aria": "Imechakatwa kwenye kifaa",
    "applyToNote_title": "Tumia kwenye dokezo",
    "applyToNote_aria": "Tumia muhtasari kwenye dokezo",
    "summaryLabel": "Muhtasari",
    "keyPointsLabel": "Hoja Muhimu",
    "noKeyPoints": "Hakuna hoja muhimu zilizorudishwa kwa dokezo hili."
  },
  "export": {
    "markdown": "Hamisha kama Markdown",
    "plainText": "Hamisha kama Maandishi Sahili",
    "pdf": "Hamisha kama PDF",
    "allZip": "Hamisha zote kama ZIP",
    "label": "Hamisha"
  },
  "cmdk": {
    "dialog_aria": "Paleti ya amri za AI",
    "input_placeholder": "Uliza AI au endesha amri…",
    "esc": "Esc",
    "back_aria": "Rudi",
    "translateTo": "Tafsiri hadi",
    "language_placeholder": "Lugha…",
    "aiActions": "Vitendo vya AI",
    "noCommandsMatch": "Hakuna amri zinazolingana na \"{{query}}\"",
    "continue": {
      "label": "Endelea kuandika",
      "description": "Endelea kutoka pale ulipoishia"
    },
    "summarize": {
      "label": "Fanya muhtasari wa uteuzi",
      "description": "Fupisha hadi hoja muhimu"
    },
    "formal": {
      "label": "Ifanye rasmi",
      "description": "Inua sauti hadi ya kitaaluma"
    },
    "simplify": {
      "label": "Rahisisha",
      "description": "Lugha fupi na iliyo wazi zaidi"
    },
    "translate": {
      "label": "Tafsiri hadi…",
      "description": "Tafsiri hadi lugha nyingine"
    },
    "expand": {
      "label": "Panua alama hii",
      "description": "Kuza alama iliyochaguliwa hadi maandishi"
    },
    "languages": {
      "Spanish": "Kihispania",
      "Arabic": "Kiarabu",
      "French": "Kifaransa",
      "German": "Kijerumani",
      "Japanese": "Kijapani",
      "Portuguese": "Kireno"
    }
  },
  "templates": {
    "dialog_aria": "Chagua kiolezo",
    "header": "Chagua Kiolezo",
    "builtInLabel": "Vilivyojengwa",
    "myTemplatesLabel": "Violezo Vyangu",
    "saveCurrent": "Hifadhi dokezo la sasa kama kiolezo",
    "myTemplatesEmpty": "Violezo vyako vilivyohifadhiwa vitaonekana hapa",
    "useTemplate": "Tumia Kiolezo",
    "meeting": {
      "name": "Madokezo ya Mkutano",
      "description": "Nasa maamuzi na hatua za kuchukua",
      "structure": "Washiriki / Ajenda / Madokezo / Hatua"
    },
    "journal": {
      "name": "Shajara ya Kila Siku",
      "description": "Tafakari kuhusu siku yako",
      "structure": "Shukrani / Mafanikio ya leo / Madokezo"
    },
    "book": {
      "name": "Muhtasari wa Kitabu",
      "description": "Nasa mawazo muhimu kutoka kwenye kitabu",
      "structure": "Wazo kuu / Nukuu muhimu / Mafunzo"
    },
    "project": {
      "name": "Muhtasari wa Mradi",
      "description": "Eleza wigo, malengo, na wadau",
      "structure": "Lengo / Wigo / Hatari / Ratiba"
    },
    "brainstorm": {
      "name": "Bungua Bongo",
      "description": "Nasa mawazo kwa uhuru",
      "structure": "Mada / Mawazo / Hatua zinazofuata"
    },
    "weekly": {
      "name": "Mapitio ya Wiki",
      "description": "Pitia na panga wiki yako",
      "structure": "Mafanikio / Changamoto / Maeneo ya kuzingatia"
    }
  },
  "voice": {
    "dialog_aria": "Kinasa dokezo la sauti",
    "cancel_aria": "Ghairi",
    "statusRecording": "Inarekodi",
    "statusTranscribing": "Inanukuu…",
    "statusReview": "Pitia",
    "skip": "Ruka",
    "mark": "Weka alama",
    "mark_title": "Weka alama ya muda",
    "captureMeeting": "Nasa mkutano",
    "captureMeeting_title": "Pia nasa sauti kutoka kichupo cha mkutano",
    "meeting": "Mkutano",
    "meeting_title": "Inanasa kichupo cha mkutano",
    "markers_aria": "Alama za muda",
    "listening": "Inasikiliza…",
    "micDenied": "Ufikiaji wa maikrofoni umezimwa. Uruhusu katika Mipangilio, kisha ujaribu tena.",
    "captureFailed": "Kurekodi hakukuweza kuanza. Jaribu tena baada ya muda mfupi.",
    "tabPicker_aria": "Chagua kichupo cha mkutano cha kunasa",
    "captureFrom": "Nasa sauti kutoka…",
    "noAudibleTab": "Hakuna kichupo kinachocheza sauti. Fungua mkutano wako na uhakikishe mtu anazungumza, kisha jaribu tena.",
    "tabPickerCancel": "Ghairi",
    "tabTranscript": "Nukuu",
    "structuring": "Inapanga…",
    "structuredNote": "Dokezo Lililopangwa",
    "structureFailed": "Imeshindwa kuunda dokezo lililopangwa.",
    "retryStructure": "Jaribu tena",
    "browserTranscript": "Nukuu ya kivinjari",
    "nothingCaptured": "Hakuna kilichonaswa.",
    "buildingStructured": "Inajenga dokezo lililopangwa…",
    "cancel": "Ghairi",
    "stop": "Simamisha",
    "recordAgain": "Rekodi tena",
    "saveToNote": "Hifadhi kwenye Dokezo",
    "statusMeeting": "Mkutano",
    "captureStrip_aria": "Inanasa sauti kutoka {{tab}}",
    "stopCapture": "Simamisha unasaji",
    "stopCapture_title": "Simamisha kunasa kichupo — maikrofoni inaendelea kurekodi",
    "stopsIn": "Itasimama baada ya {{time}}",
    "autoStopped": "Urekodi ulisimama kwenye kikomo cha dakika 60.",
    "autoStoppedQuota": "Urekodi ulisimama — umetumia dakika za unukuzi za mwezi huu.",
    "captureLost": "Kichupo cha mkutano kimefungwa. Maikrofoni yako bado inarekodi.",
    "tabSummary": "Muhtasari",
    "noSpeakers": "Wazungumzaji hawakutambuliwa",
    "speakerN": "Mzungumzaji {{number}}",
    "renameSpeaker_aria": "Badilisha jina la {{name}} — inatumika kwa mistari yake yote",
    "renameSpeaker_input_aria": "Jina la mzungumzaji",
    "turnTime_title": "Ilisemwa saa {{time}}",
    "actionItemsTitle": "Hatua za Kuchukua",
    "actionsCount": "{{checked}} kati ya {{total}}",
    "addToTasks_one": "Ongeza {{count}} kwenye Kazi",
    "addToTasks_other": "Ongeza {{count}} kwenye Kazi",
    "addToTasksZero": "Ongeza kwenye Kazi",
    "adding": "Inaongeza…",
    "tasksAdded_one": "Kazi {{count}} imeongezwa",
    "tasksAdded_other": "Kazi {{count}} zimeongezwa",
    "viewTasks": "Tazama",
    "addFailed": "Imeshindwa kuongeza — jaribu tena.",
    "minutesLeft_one": "Dakika {{count}} imebaki",
    "minutesLeft_other": "Dakika {{count}} zimebaki",
    "minutesLeftShort_one": "Dakika {{count}} imebaki",
    "minutesLeftShort_other": "Dakika {{count}} zimebaki",
    "minutesLeft_title": "Dakika {{count}} za unukuzi zimebaki mwezi huu",
    "quotaExhausted": "Umetumia dakika za mikutano za mwezi huu. Zitasasishwa {{date}}.",
    "quotaUnknown": "Dakika zilizobaki hazijulikani — rekodi inaweza kufikia kikomo chako cha mwezi",
    "meetingProRequired": "Unukuzi wa mikutano ni sehemu ya Pro. Nukuu yako ya moja kwa moja imehifadhiwa hapa chini.",
    "gateTitle": "Kurekodi mikutano",
    "gateBody": "Rekodi kichupo cha mkutano pamoja na maikrofoni yako — wazungumzaji wakitambuliwa na hatua zikitolewa. Imejumuishwa na Pro.",
    "gateLater": "Si sasa",
    "gateCta": "Angalia Pro",
    "roomOption": "Hakuna kichupo — rekodi chumba",
    "roomHint": "Simu kwenye spika, programu ya kando, au watu ndani ya chumba — chochote unachoweza kusikia kwa sauti.",
    "roomHint_title": "Ikiwa upande mwingine uko kwenye hedifoni zako, maikrofoni haiwezi kuwasikia — tumia spika.",
    "recordRoom": "Rekodi chumba",
    "recordRoom_title": "Rekodi kila mtu anayesikika na maikrofoni — wazungumzaji wakitambuliwa",
    "roomStart": "Anza",
    "statusRoom": "Chumba",
    "roomStrip": "Inarekodi chumba",
    "roomStrip_aria": "Inarekodi chumba — kila mtu anayesikika na maikrofoni",
    "roomOff": "Zima",
    "roomOff_title": "Zima hali ya chumba — hii inakuwa dokezo la sauti la kawaida",
    "roomRenameHint": "Gusa jina ili ulibadilishe — mmoja wao ni wewe.",
    "gateBodyRoom": "Rekodi kinachosemwa karibu nawe — wazungumzaji wakitambuliwa na hatua zikitolewa. Imejumuishwa na Pro.",
    "roomHintDevice": "Simu za kifaa hiki haziwezi kurekodiwa — iOS huzihifadhi kuwa za faragha. Simu nyingine kwenye spika, au mazungumzo ndani ya chumba, yanafanya kazi.",
    "autoStoppedSize": "Urekodi ulisimama kwenye kikomo cha ukubwa wa upakiaji.",
    "tooLarge": "Rekodi ilikuwa kubwa mno kupakiwa, hivyo haikuweza kunukuliwa.",
    "destTo": "Kwa",
    "dest_aria": "Ongeza kwenye orodha: {{name}}",
    "destMenu_aria": "Chagua orodha",
    "destNewPending_aria": "Orodha mpya: {{name}}"
  },
  "meetingNotice": {
    "title": "Mikutano, kwenye madokezo yako",
    "body": "Rhemn sasa inaweza kurekodi kichupo cha mkutano unachochagua — tu unaporekodi dokezo la sauti, na kichupo unachokichagua pekee.",
    "factPrivacy": "Sauti huchakatwa kuunda nukuu yako, kisha hutupwa. Rekodi hazihifadhiwi kamwe.",
    "factControl": "Hakuna kinachonaswa hadi ubonyeze kurekodi na kuchagua kichupo.",
    "cta": "Nimeelewa",
    "privacyLink": "Soma sera yetu ya faragha",
    "dialog_aria": "Kuhusu ruhusa mpya ya kurekodi mikutano"
  }
}
